// LLM chat actions module (direct chat to /api/llms/chat)
import { llmApi } from '@/services/api'

export default {
  namespaced: true,
  state: { loading: false, error: null },
  mutations: { SET_LOADING(s,v){s.loading=v}, SET_ERROR(s,e){s.error=e} },
  actions: {
    async send({ commit }, payload) {
      try { commit('SET_LOADING', true); commit('SET_ERROR', null); return await llmApi.chat(payload) }
      catch (e) { commit('SET_ERROR', e.message || 'LLM chat failed'); throw e }
      finally { commit('SET_LOADING', false) }
    }
  }
}
